export default __webpack_public_path__ + "static/media/youtube.151d7718.svg";